import {
  Button,
  Checkbox,
  DatePicker,
  Input,
  Select,
  Space,
  Spin,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import NextDateIcon from "../../../assets/icons/NextDateIcon";
import PrevDateIcon from "../../../assets/icons/PrevDateIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import SettingIcon from "../../../assets/icons/SettingIcon";
import IMG from "../../../assets/images/avatar.svg";
import IMG2 from "../../../assets/images/shift-management/active-employee.svg";
import IMG4 from "../../../assets/images/shift-management/general-attendance.svg";
import IMG1 from "../../../assets/images/shift-management/total-shift.svg";
import IMG3 from "../../../assets/images/shift-management/under-shift.svg";
import AssignShiftModal from "../../../components/Attendance/ShiftManagement/AssignShiftModal";
import BulkAssignModal from "../../../components/Attendance/ShiftManagement/BulkAssignModal";
import PreviousGeneralAttendance from "../../../components/Attendance/ShiftManagement/PreviousGeneralAttendance";
import ShiftTopCard from "../../../components/Attendance/ShiftManagement/ShiftTopCard";
import TopCard from "../../../components/common/TopCard";
import ReportRequestModal from "../../../components/Report/ReportRequestModal";
import SuccessModal from "../../../components/Report/SuccessModal";
import ConfirmModal from "../../../components/ui/ConfirmModal";
import CustomPagination from "../../../components/ui/CustomPagination";
import Loader from "../../../components/ui/Loader";
import colors from "../../../constants/colors";
import {
  dbDateFormat,
  employeeSearchTypeList,
} from "../../../constants/constants";
import { useGetBusinessShiftsQuery } from "../../../features/businessShift/businessShiftApi";
import { useGetDepartmentsQuery } from "../../../features/department/departmentApi";
import { useGetDesignationsQuery } from "../../../features/designation/designationApi";
import { useGetEmployeeDetailsQuery } from "../../../features/employee/employeeApi";
import { useShiftAssignListReportMutation } from "../../../features/report/reportApi";
import {
  useGetShiftCalenderQuery,
  useGetShiftCartDataQuery,
  useUpdatePreviousWeekendStatusMutation,
} from "../../../features/shiftAssignToEmployee/shiftAssignToEmployeeApi";
import useDebounce from "../../../hooks/useDebounce";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatOnlyTime } from "../../../lib/time";
import { toast } from "../../../lib/toast";
import { addZeroIfInRange } from "../../../utils/number";
import {
  hexToRgba,
  selectArrayOptionWithAll,
  selectSearchOption,
  selectStringOption,
  skipData,
  underscoreToCapitalizeString,
} from "../../../utils/utils";

const searchTypeSelect = employeeSearchTypeList?.map((item) => ({
  label: underscoreToCapitalizeString(item),
  value: item,
}));

type ModalType =
  | "BULK"
  | "CONFIRM"
  | "PREVIOUS_GENERAL"
  | "REPORT_REQUEST"
  | "SUCCESS";

export default function ShiftManagement() {
  // const navigate = useNavigate();
  const { keyword, handleInputChange } = useDebounce();
  const { authInfo } = useAppSelector((state) => state.auth);
  const [clicked, setClicked] = useState<"next" | "prev" | undefined>(
    undefined
  );
  const { page, limit, handlePagination, resetPagination, handleLimit } =
    useTable();
  const { open, handleOpen, handleClose } = useModal<
    any | undefined,
    ModalType
  >();
  const [departmentId, setDepartmentId] = useState<string | undefined>();
  const [designationId, setDesignationId] = useState<string | undefined>();
  const [shiftId, setShiftId] = useState<string | undefined>();
  const [selectEmployee, setSelectEmployee] = useState<number[]>([]);
  const [searchType, setSearchType] =
    useState<(typeof employeeSearchTypeList)[number]>("name");
  const [dates, setDates] = useState(() =>
    Array.from({ length: 7 }, (_, i) => dayjs().add(i, "day"))
  );

  const {
    isError: isDepartmentError,
    error: departmentError,
    data: departmentData,
  } = useGetDepartmentsQuery({
    params: { skip: 0, limit: 0, is_published: 1 },
  });
  const {
    data: designationData,
    isError: isDesignationError,
    error: designationError,
  } = useGetDesignationsQuery(
    {
      params: {
        limit: 0,
        skip: 0,
        ...(departmentId
          ? { business_department_id: departmentId?.toString() || "" }
          : {}),
      },
    },
    {
      skip: !departmentId,
    }
  );
  const { isLoading, isError, error, data, isFetching } =
    useGetShiftCalenderQuery({
      params: {
        limit,
        skip: skipData(page, limit),
        start_date: dates[0].format(dbDateFormat),
        end_date: dates[6].format(dbDateFormat),
        business_department_id:
          departmentId === "all" ? undefined : departmentId,
        business_role_id: designationId === "all" ? undefined : designationId,
        ...(keyword ? { search_type: searchType } : {}),
        search: keyword,
        shift_name: shiftId === "all" ? undefined : shiftId,
        manager_id: authInfo?.role === "Manager" ? authInfo?.id : undefined,
        // employee_type: employeeType,
      },
    });
  const {
    isError: isCardError,
    error: cardError,
    data: cartData,
    isLoading: isCartLoading,
  } = useGetShiftCartDataQuery({
    params: {
      manager_id: authInfo?.role === "Manager" ? authInfo?.id : undefined,
    },
  });
  const [
    updatePreviousWeekendStatus,
    {
      isLoading: isPreviousWeekendLoading,
      isSuccess: isPreviousWeekendSuccess,
      isError: isPreviousWeekendError,
      error: previousWeekendError,
      // data: previousWeekendData,
    },
  ] = useUpdatePreviousWeekendStatusMutation();

  const {
    data: userData,
    // isLoading: userLoading,
    isError: isEmployeeDetailsError,
    error: employeeDetailsError,
  } = useGetEmployeeDetailsQuery(authInfo?.id?.toString() || "", {
    skip: !authInfo?.id,
  });
  const {
    isLoading: isBusinessShiftLoading,
    isError: isBusinessShiftError,
    error: businessShiftError,
    data: businessShift,
  } = useGetBusinessShiftsQuery({
    params: {
      // limit,
      // skip: skipData(page, limit),
    },
  });

  const isEmailVerified =
    userData?.data?.employee?.member?.profile?.email_verified;
  const [
    shiftAssignListReport,
    {
      isLoading: isGenerateLoading,
      isError: isGenerateError,
      error: generateError,
      isSuccess: isGenerateSuccess,
    },
  ] = useShiftAssignListReportMutation();
  useError(isGenerateError, generateError, "Generate request report fail");
  useError(isDepartmentError, departmentError, "Get department data fail");
  useError(isDesignationError, designationError, "Get designation fail");
  useError(isError, error, "Get shift management data fail");
  useError(isCardError, cardError, "Get shift card data fail");
  useError(isEmployeeDetailsError, employeeDetailsError, "Get user data fail");
  useError(
    isPreviousWeekendError,
    previousWeekendError,
    "Update previous weekend status fail"
  );
  useError(
    isBusinessShiftError,
    businessShiftError,
    "Get business shift data fail"
  );

  const topBar = [
    {
      title: "Total Shifts",
      count: cartData?.data?.totalShift ?? 0,
      icon: IMG1,
      color: colors.info.color,
      bg: "#f3faff",
    },
    {
      title: "Total Active Employees",
      count: cartData?.data?.totalActiveEmployee ?? 0,
      icon: IMG2,
      color: "#4a71ff",
      bg: "#f2f5ff",
    },
    {
      title: "Under Shifts",
      count: cartData?.data?.underShiftEmployee ?? 0,
      icon: IMG3,
      color: "#3caaf9",
      bg: "#f3faff",
    },
    {
      title: "Under General Attendance",
      count: cartData?.data?.generalAttendanceEmployee ?? 0,
      icon: IMG4,
      color: "#ffc700",
      bg: "#fff8df",
    },
    // {
    //   title: "Unassigned",
    //   count: 5,
    //   icon: IMG5,
    //   color: "#ff574c",
    //   bg: "#fff4f4",
    // },
  ];

  // Handle date range change
  const handleDateChange = (date: any) => {
    if (date) {
      const newDates = Array.from({ length: 7 }, (_, i) =>
        date.add(i, "day")
      );
      setDates(newDates);
      resetPagination();
    }
  };

  // Navigate to the previous week
  const handlePrevWeek = () => {
    if (!allowNext && clicked === "prev") return null;
    setClicked("prev");
    const startOfPrevWeek = dayjs(dates[0]).subtract(1, "week");
    const newDates = Array.from({ length: 7 }, (_, i) =>
      startOfPrevWeek.add(i, "day")
    );
    setDates(newDates);
  };

  // Navigate to the next week
  const handleNextWeek = () => {
    if (!allowNext && clicked === "next") return null;
    setClicked("next");
    const startOfNextWeek = dayjs(dates[0]).add(1, "week");
    const newDates = Array.from({ length: 7 }, (_, i) =>
      startOfNextWeek.add(i, "day")
    );
    setDates(newDates);
  };

  const handleSelect = (checked: boolean, id: number) => {
    if (checked) {
      return setSelectEmployee((prev) => [...prev, id]);
    }

    return setSelectEmployee((prev) => prev.filter((item) => item !== id));
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      return setSelectEmployee(
        employees
          .map((item) => item?.business_member_id)
          .filter((id): id is number => id !== undefined)
      );
    }

    return setSelectEmployee([]);
  };

  const employees = Object.keys(data?.data?.shift_calender_employee || {})?.map(
    (key) => {
      const shiftData =
        data?.data?.shift_calender_employee[
          key as keyof typeof data.data.shift_calender_employee
        ];
      if (!shiftData) return null;
      const { employee, date } = shiftData;
      return {
        ...employee,
        shifts: date?.map((shift) => ({
          type: shift?.is_weekend
            ? "Weekend"
            : shift?.is_holiday
            ? "Holiday"
            : shift?.is_shift && "shift_title" in shift
            ? shift?.shift_title
            : shift?.is_unassigned
            ? "Un Assigned"
            : "General Attendance",
          time:
            shift?.is_shift &&
            "shift_start" in shift &&
            "shift_end" in shift &&
            shift?.shift_start &&
            shift?.shift_end
              ? `${formatOnlyTime(shift?.shift_start)} - ${formatOnlyTime(
                  shift?.shift_end
                )}`
              : undefined,
          date: shift?.date,
          shift_color: shift?.is_weekend
            ? "#10afc7"
            : shift?.is_holiday
            ? colors.highlight
            : shift?.is_unassigned
            ? colors.displayBody
            : shift?.shift_color || "",
          allData: shift,
        })),
      };
    }
  );

  useEffect(() => {
    if (keyword) resetPagination();
  }, [keyword, resetPagination]);

  useEffect(() => {
    setSelectEmployee([]);
  }, [page]);

  useEffect(() => {
    if (isPreviousWeekendSuccess) {
      toast("success", "Previous weekend update successfully");
      handleOpen({ type: "SUCCESS" });
      // handleClose();
      // if (previousWeekendData?.data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPreviousWeekendSuccess]);

  const shiftOptions = [
    { title: "All", name: "all" },
    { title: "General", name: "general" },
    ...(businessShift?.data?.shifts || []),
  ];

  const shiftOptionsList = shiftOptions.map((item, idx) => ({
    label: item.title,
    value: item.name,
    key: `${item.name}_${idx}`,
  }));

  const allowNext = !employees
    ?.map((ep) => ep?.shifts)
    .every((array) => array?.length === 0);

  return (
    <SidebarLayout title="Shift Management">
      {open?.type === "SUCCESS" && (
        <SuccessModal
          type="queue"
          open={open?.open}
          handleClose={handleClose}
        />
      )}
      {open.type === "ADD" && (
        <AssignShiftModal
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
      {open.type === "BULK" && selectEmployee?.length && (
        <BulkAssignModal
          open={open.open}
          data={open.data}
          handleClose={handleClose}
        />
      )}

      {open?.type === "CONFIRM" && (
        <ConfirmModal
          open={open?.open}
          handleOk={() => {
            updatePreviousWeekendStatus({});
          }}
          handleClose={handleClose}
          okText="Confirm"
          confirmTitle="Update Previous Weekend Status"
          questionText="Are you want to update previous weekend status?"
          okLoading={isPreviousWeekendLoading}
        />
      )}

      {open?.type === "PREVIOUS_GENERAL" && (
        <PreviousGeneralAttendance open={open.open} handleClose={handleClose} />
      )}

      {open.type === "REPORT_REQUEST" && (
        <ReportRequestModal
          open={open.open}
          handleClose={handleClose}
          isLoading={isGenerateLoading}
          isSuccess={isGenerateSuccess}
          handleSubmit={(params: any) => {
            shiftAssignListReport({
              body: {
                name: "Shift Assign report",
              },
              params: {
                ...params,
                business_department_id: departmentId,
                business_role_id: designationId,
                ...(keyword ? { search_type: searchType } : {}),
                search: keyword,
                shift_name: shiftId,
                manager_id:
                  authInfo?.role === "Manager" ? authInfo?.id : undefined,
              },
            });
          }}
        />
      )}

      <div className="">
        <div
          className={`sticky inset-x-0 z-50 ${
            !isEmailVerified ? "!top-[127px]" : "top-20"
          }`}
        >
          {isCartLoading ? (
            <CartDataPlaceholder />
          ) : (
            <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-3 mb-6 ">
              {topBar.map((item, index) => (
                <ShiftTopCard key={item.title + index} {...item} />
              ))}
            </div>
          )}

          <TopCard
            className="!mb-2.5"
            leftChildren={
              <>
                <div className="flex items-center gap-2.5 text-body text-sm font-semibold">
                  <span>Per Page</span>
                  <Select
                    size="small"
                    showSearch
                    value={limit}
                    onChange={handleLimit}
                    filterOption={selectSearchOption}
                    options={selectStringOption(
                      ["10", "20", "50", "100", "1000"],
                      "number"
                    )}
                    className="min-w-[70px]"
                    suffixIcon={<SelectDownIcon />}
                  />
                  <span>
                    of {addZeroIfInRange(data?.data?.totalLength || 0)}
                  </span>
                </div>
                <Select
                  showSearch
                  placeholder="Search Type"
                  value={searchType}
                  options={searchTypeSelect}
                  onChange={(val) => {
                    setSearchType(val);
                    resetPagination();
                  }}
                  filterOption={selectSearchOption}
                  className="min-w-[100px]"
                  suffixIcon={<SelectDownIcon />}
                  rootClassName="icon-gray"
                />
                <Input
                  suffix={<SearchIcon />}
                  placeholder={`Search by ${underscoreToCapitalizeString(
                    searchType,
                    true
                  )}`}
                  style={{ minWidth: 180 }}
                  onChange={(val) => {
                    handleInputChange(val);
                  }}
                />
                <Button
                  type="primary"
                  className="!bg-[#001652] sm-button !px-3"
                  onClick={() =>
                    handleOpen({
                      type: "BULK",
                      data: selectEmployee,
                    })
                  }
                  disabled={!selectEmployee?.length}
                >
                  Bulk Shift Assign
                </Button>
                {authInfo?.role === "Admin" && (
                  <>
                    <Button
                      className="outline-button-primary"
                      size="middle"
                      onClick={() => {
                        handleOpen({ type: "PREVIOUS_GENERAL" });
                      }}
                    >
                      Update previous shift to general
                    </Button>
                    <Button
                      className="outline-button-primary"
                      size="middle"
                      onClick={() => {
                        handleOpen({ type: "CONFIRM" });
                      }}
                      loading={isPreviousWeekendLoading}
                    >
                      Update Previous Weekend Status
                    </Button>
                  </>
                )}

                <DatePicker
                  onChange={handleDateChange}
                  picker="week"
                  value={dates[0]}
                  className="max-w-[200px] clear-button-hide relative input-center shift-management"
                  open={false}
                  format={() => {
                    return `${dayjs(dates[0]).format("DD MMM")} - ${dayjs(
                      dates[6]
                    ).format("DD MMM")}` as unknown as string;
                  }}
                  suffixIcon={
                    <div>
                      <span
                        onClick={handlePrevWeek}
                        className={`absolute left-0 top-2/4 -translate-y-2/4 z-20 select-none pointer-events-auto ${
                          !allowNext && clicked === "prev"
                            ? "cursor-not-allowed text-gray"
                            : "cursor-pointer text-primary"
                        }`}
                      >
                        <PrevDateIcon />
                      </span>
                      <span
                        onClick={handleNextWeek}
                        className={`absolute right-0 top-2/4 -translate-y-2/4 z-20 select-none pointer-events-auto ${
                          !allowNext && clicked === "next"
                            ? "cursor-not-allowed text-gray"
                            : "cursor-pointer text-primary"
                        }`}
                      >
                        <NextDateIcon />
                      </span>
                    </div>
                  }
                />
                <Select
                  allowClear
                  showSearch
                  placeholder="Department"
                  value={departmentId}
                  options={selectArrayOptionWithAll(
                    departmentData?.data?.departments || [],
                    "name",
                    "id"
                  )}
                  onChange={(val) => {
                    setDepartmentId(val);
                    setDesignationId(undefined);
                    resetPagination();
                  }}
                  filterOption={selectSearchOption}
                  className="min-w-[130px]"
                  suffixIcon={<SelectDownIcon />}
                  rootClassName="icon-gray"
                />

                <Select
                  allowClear
                  showSearch
                  placeholder="Designation"
                  value={designationId}
                  options={selectArrayOptionWithAll(
                    designationData?.data?.roles || [],
                    "name",
                    "id"
                  )}
                  onChange={(val) => {
                    setDesignationId(val);
                    resetPagination();
                  }}
                  disabled={!departmentId}
                  filterOption={selectSearchOption}
                  className="min-w-[130px]"
                  suffixIcon={<SelectDownIcon />}
                  rootClassName="icon-gray"
                />
                {/* <Select
          allowClear
          showSearch
          placeholder="Employee Type"
          value={employeeType}
          options={selectStringOption(
            employeeTypeList as unknown as string[],
            "string",
            true
          )}
          onChange={(val) => {
            setEmployeeType(val);
            resetPagination();
          }}
          filterOption={selectSearchOption}
          className="min-w-[130px]"
          suffixIcon={<SelectDownIcon />}
          rootClassName="icon-gray"
        /> */}
                <Select
                  allowClear
                  showSearch
                  placeholder="Shift"
                  value={shiftId}
                  options={shiftOptionsList}
                  onChange={(val) => {
                    setShiftId(val);
                    resetPagination();
                  }}
                  optionLabelProp="label"
                  popupMatchSelectWidth={200}
                  filterOption={selectSearchOption}
                  className="min-w-[130px]"
                  suffixIcon={<SelectDownIcon />}
                  rootClassName="icon-gray"
                  loading={isBusinessShiftLoading}
                />
                <Button
                  onClick={() => handleOpen({ type: "REPORT_REQUEST" })}
                  className="download-button"
                  icon={<DownloadIcon />}
                >
                  Report Requests
                </Button>
                <Link to="/admin/settings/office-settings/shift">
                  <Button
                    type="primary"
                    className="middle-button"
                    icon={<SettingIcon />}
                  />
                </Link>
              </>
            }
          ></TopCard>
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <div
            className="custom-scrollbar overflow-x-auto relative"
            style={{ maxHeight: `calc(100vh - 280px)` }}
          >
            <div className="min-w-[1080px]">
              <div className="flex items-center gap-1 bg-gray-100 font-semibold sticky top-0 !bg-white z-10">
                <h4 className="w-[350px] min-h-20 px-4 py-2.5 bg-white border border-extra-light flex-col justify-center flex text-left text-body text-lg font-semibold">
                  <div className="flex items-center gap-2">
                    <Checkbox
                      checked={
                        employees?.length > 0
                          ? employees?.length === selectEmployee?.length
                          : false
                      }
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />{" "}
                    Employee Name
                  </div>
                </h4>
                <div className="flex-1 grid grid-cols-7 gap-1">
                  {dates?.map((date) => (
                    <div
                      key={date.format("YYYY-MM-DD")}
                      className=" min-h-20 p-3 bg-white border border-extra-light flex-col justify-start items-center inline-flex text-center"
                    >
                      <small className="text-display-body text-base font-medium">
                        {date.format("ddd")}
                      </small>

                      <span className="flex items-center gap-1">
                        <h6 className="text-display-body text-xl font-semibold">
                          {date.format("DD")}
                        </h6>
                        <small className="text-body-text text-sm font-medium leading-normal mt-0.5">
                          {date.format("MMM")}
                        </small>
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Employee Rows */}
              {employees?.map((employee, idx) => {
                return (
                  <div
                    key={idx}
                    className="flex gap-1 items-center text-sm pt-1"
                  >
                    <div className="w-[350px] h-[105px] px-4 py-2.5 bg-white border border-extra-light">
                      <Space align="center" className="h-full" size={16}>
                        <div className="flex items-center gap-1">
                          <Checkbox
                            checked={
                              !!selectEmployee?.find(
                                (item) => item === employee?.business_member_id
                              )
                            }
                            onChange={(val) =>
                              employee?.business_member_id &&
                              handleSelect(
                                val.target.checked,
                                employee?.business_member_id
                              )
                            }
                          />
                          <div className="w-14 h-14 justify-center items-center inline-flex">
                            <img
                              className="w-full h-full rounded-full"
                              src={employee?.pro_pic || IMG}
                              alt=""
                            />
                          </div>
                        </div>
                        <div>
                          <h5 className="text-body text-base font-semibold">
                            {employee?.name}
                          </h5>
                          <p className="text-extra-gray text-sm font-medium">
                            ID: {employee?.employee_id || "n/a"}
                          </p>
                          <p className="text-display-body text-sm font-medium">
                            Department: {employee?.department_name}
                          </p>
                          <p className="text-display-body text-sm font-medium flex items-center gap-1">
                            Email:{" "}
                            <Tooltip title={employee?.email} placement="top">
                              {employee?.email && (
                                <a
                                  href={`mailto:${employee.email}`}
                                  className="!text-accent hover:underline truncate max-w-[11.3rem] inline-block"
                                >
                                  {employee.email}
                                </a>
                              )}
                            </Tooltip>
                          </p>
                        </div>
                      </Space>
                    </div>
                    <div className="flex-1 grid grid-cols-7 gap-1 h-full">
                      {dates?.map((date) => {
                        const matchingShift = employee?.shifts?.find(
                          (shift) =>
                            moment(shift?.date)?.format(dbDateFormat) ===
                            date?.format(dbDateFormat)
                        );

                        const type = matchingShift?.type;

                        if (isFetching) {
                          return (
                            <div
                              className="h-[105px] p-3 border border-extra-light flex justify-center items-center"
                              key={date.format(dbDateFormat)}
                            >
                              <Spin />
                            </div>
                          );
                        }

                        return (
                          <div
                            key={date.format(dbDateFormat)}
                            className={`h-[105px] p-3 border border-extra-light text-sm font-medium relative ${
                              date.isBefore(dayjs().startOf("day"))
                                ? //  || !matchingShift?.allData TODO:
                                  "cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
                            style={
                              type || matchingShift?.allData
                                ? {
                                    backgroundColor: matchingShift?.shift_color
                                      ? hexToRgba(matchingShift?.shift_color)
                                      : "#fff",
                                  }
                                : !matchingShift?.allData
                                ? {
                                    background:
                                      "linear-gradient(47deg, #eceaea 15%, rgba(246, 130, 130, 0.4) 18%, #eceaea 20%, #eceaea 35%, rgba(246, 130, 130, 0.4) 38%, #eceaea 40%, #eceaea 55%, rgba(246, 130, 130, 0.4) 58%, #eceaea 60%, #eceaea 75%, rgba(246, 130, 130, 0.4) 78%, #eceaea 80%)",
                                  }
                                : {}
                            }
                            onClick={() => {
                              if (
                                !date.isBefore(dayjs().startOf("day"))
                                // && matchingShift?.allData TODO:
                              ) {
                                handleOpen({
                                  type: "ADD",
                                  data: {
                                    business_member_id:
                                      employee?.business_member_id,
                                    date: date.format(dbDateFormat),
                                    data: matchingShift?.allData,
                                  },
                                });
                              }
                            }}
                          >
                            <>
                              {type || matchingShift?.allData ? (
                                <div
                                  className="absolute left-0 top-0 h-full w-1"
                                  style={{
                                    backgroundColor:
                                      matchingShift?.shift_color || "#fff",
                                  }}
                                />
                              ) : null}
                              <h6 className="text-display-body">
                                {type
                                  ? type
                                  : matchingShift?.allData
                                  ? "General Attendance"
                                  : !matchingShift?.allData
                                  ? "Shift Not Enabled"
                                  : "General Attendance"}
                              </h6>
                              {matchingShift?.time && (
                                <span className="text-body-text block mt-1.5 leading-tight">
                                  {matchingShift?.time}
                                </span>
                              )}
                            </>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="min-w-[1080px]">
              {data?.data?.totalLength ? (
                <CustomPagination
                  limit={limit}
                  page={page}
                  total={data?.data?.totalLength}
                  handlePagination={handlePagination}
                  className="bg-white mt-2.5 rounded border border-extra-light"
                />
              ) : null}
            </div>
          </div>
        )}
      </div>
    </SidebarLayout>
  );
}

function CartDataPlaceholder() {
  return (
    <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-3">
      {[...Array(4)].map((_, index) => (
        <div key={index} className="w-full h-20 bg-slate-100 rounded-md"></div>
      ))}
    </div>
  );
}
